import React from "react";
import { IPage } from "../../../api/entities/page";
import Table, {
  IColumnDefinition,
  TableSelected,
} from "../../shared-ui/table/table";
import tableStyles from "../../shared-ui/table/table.module.scss";
import styles from "./access-credentials-table.module.scss";
import { MoreOption } from "./moreoption";
import { IAppState } from "../../../redux/reducers";
import { connect } from "react-redux";
import {
  IAMCredentialSortField,
  IAMCredentialStatus,
  IIAMCredentialMeta,
} from "api/entities/iam-credentials";
import { IIAMEntityRequestParams } from "api/entities/iam-entity";
import IAMCredentialStatusToggle from "./status";
import { Formatters } from "helper/formatters";

const mapStateToProps = (state: IAppState) => ({
  accountType: state.users.currentUser.accountType,
});

export interface IApplicationTableProps
  extends ReturnType<typeof mapStateToProps> {
  isLoading: boolean;
  page: IPage<IIAMCredentialMeta>;
  requestParams: IIAMEntityRequestParams<IAMCredentialSortField>;
  onRequestParamsChanged: (
    data?: IIAMEntityRequestParams<IAMCredentialSortField>
  ) => void;

  selection?: TableSelected<IIAMCredentialMeta>;
  onSelectionChanged?: (selection: TableSelected<IIAMCredentialMeta>) => void;
  onSelectAll?: () => void;

  hasManageColumn?: boolean;
}

export const AccessCredentialsTable = connect(
  mapStateToProps,
  null
)((props: IApplicationTableProps) => {
  const columns: IColumnDefinition<IIAMCredentialMeta, string>[] = [
    {
      label: "User",
      className: styles["col--name"],
      formatter: (row) => row.UserName,
      sortKey: IAMCredentialSortField.UserName,
    },
    {
      label: "Key",
      formatter: (row) => row.AccessKeyId,
      sortKey: IAMCredentialSortField.AccessKey,
    },
    {
      label: "Created AT",
      formatter: (row) => Formatters.formatDateTime(row.CreateDate),
      sortKey: IAMCredentialSortField.CreateDate,
    },
    {
      label: "Status",
      formatter: (row) => <IAMCredentialStatusToggle data={row} refresh={props.onRequestParamsChanged}/>,
      sortKey: IAMCredentialSortField.Status,
    },
  ];

  if (props.hasManageColumn) {
    columns.push(
        {
          label: "Manage",
          className: tableStyles["col--manage"],
          formatter: row => {
            return <MoreOption
                data={row}
            />
          }
        }
    );
  }

  return (
    <Table
      testId="application-credentials-table"
      hideCheckbox={!props.selection}
      columns={columns}
      rows={props.page.data}
      totalRows={props.page.count}
      loading={props.isLoading}
      requestParams={props.requestParams}
      onRequestParamsChanged={props.onRequestParamsChanged}
      selected={props.selection}
      onSetSelected={props.onSelectionChanged}
      onSelectAll={props.onSelectAll}
    />
  );
});
